import type { RrMainMenuItemImpl } from '@seedkit/vue';
import {
  skClock,
  skGrid,
  skUsers,
  skStickyNote,
  skUserCatalog,
  skNote,
  skLightning,
  skCalendar,
  skPeople,
  skMeasure,
  skStar,
  skCash,
} from 'app/src/shared/icons';
import { RouteNames } from 'app/src/app/providers/router';
import { piChatCircle, piChartLineUp, piMapPin, piMoney, piSmiley } from '@seedkit/assets/phosphor-icons';
import { skFolderOpen } from '@seedkit/assets/seedkit-icons';

export const MAIN_MENU_ITEMS: Array<RrMainMenuItemImpl> = [
  {
    id: 'DE52752C-FA0B-4096-9330-E5DB6367ECF3',
    title: 'Техническая поддержка',
    icon: piChatCircle,
    visible: true,
    to: RouteNames.TechnicalSupport.Base,
    order: 19,
  },
  {
    id: 'AboutMenuItem',
    title: 'О фонде',
    to: RouteNames.About.Base,
    icon: skPeople,
    visible: true,
    order: 15,
  },
  {
    id: 'AnalyticsAndReportsNenuItem',
    title: 'Аналитика и отчетность',
    to: RouteNames.AnalyticsAndReports.Base,
    icon: piChartLineUp,
    visible: true,
    order: 1,
  },
  {
    id: 'WardsAndVolunteersMenuItem',
    title: 'Подопечные и волонтёры',
    to: RouteNames.WardsAndVolunteers.Base,
    icon: piSmiley,
    visible: true,
    order: 14,
  },
  {
    id: 'GoodDeedsBoardMenuItem',
    title: 'Доска добрых дел',
    icon: skStickyNote,
    to: RouteNames.GoodDeedsBoard.Base,
    visible: true,
    order: 8,
  },
  {
    id: 'NewsMenuItem',
    title: 'Пресс-центр',
    icon: skGrid,
    to: RouteNames.News.Base,
    visible: true,
    order: 10,
  },
  {
    id: 'F47AC10B-58CC-4372-A567-0E02B2C3D479',
    title: 'Гранты и финансы',
    icon: piMoney,
    visible: true,
    to: RouteNames.Grants.Base,
    order: 12,
  },
  {
    id: 'E4008BE7-BFC0-42BB-82E4-DB8AB6C454D3',
    title: 'Адресная помощь',
    icon: piMapPin,
    to: RouteNames.AddressCollections.Base,
    visible: true,
    order: 9,
  },
  {
    id: '10E3B201-E946-4387-BD67-2DB2DAB90C87',
    title: 'Занятия',
    icon: skClock,
    to: RouteNames.Exercises.Base,
    visible: true,
    order: 7,
  },
  {
    id: '5B2E1F9A-3C4D-4B8E-9A1F-7D6E2C8B5F4A',
    title: 'Мероприятия',
    icon: skUserCatalog,
    to: RouteNames.EventsAdmin.Base,
    visible: true,
    order: 6,
  },
  {
    id: 'GamificationMenuItem',
    title: 'Геймификация',
    icon: skStar,
    to: RouteNames.Gamification.Base,
    visible: true,
    order: 11,
  },
  {
    id: 'TasksMenuItem',
    title: 'Задачи',
    icon: skLightning,
    to: RouteNames.Tasks.Base,
    visible: true,
    order: 4,
  },
  {
    id: 'CalendarMenuItem',
    title: 'Календарь',
    icon: skCalendar,
    to: RouteNames.Calendar.Base,
    visible: true,
    order: 5,
  },
  {
    id: 'MeasuresMenuItem',
    title: 'Меры поддержки',
    icon: skMeasure,
    to: RouteNames.Measures.Base,
    visible: true,
    order: 13,
  },
  {
    id: 'ContentMenuItem',
    title: 'Контент',
    icon: skNote,
    to: RouteNames.Content.Base,
    visible: true,
    order: 16,
  },
  {
    id: 'AdvertisingMenuItem',
    title: 'Реклама',
    icon: skCash,
    to: RouteNames.Advertising.Base,
    visible: true,
    order: 17,
  },
  {
    id: '7F3A8C2E-9B4D-4E5F-A1C2-3D4E5F6A7B8C',
    title: 'Реестр пожертвований',
    to: RouteNames.DonationRegistry.Base,
    icon: skFolderOpen,
    visible: true,
    order: 2,
  },
  {
    id: 'D6DE2E0E-40C3-44A1-B2F0-56B597BD6395',
    title: 'Заявки',
    icon: skUsers,
    visible: true,
    order: 3,
    children: [
      {
        id: 'DC7197A6-5BF8-405B-A06E-61B1E4ECD6B2',
        title: 'Адресная помощь',
        visible: true,
        to: RouteNames.Applications.TargetAssistance.Base,
      },
      {
        id: '00CE5A5B-08D5-4CAC-94E8-71218D60E01F',
        title: 'События',
        visible: true,
        to: RouteNames.Applications.Events.Base,
      },
      {
        id: 'F824A6CB-18C6-409C-9E2B-A63216CEBAFD',
        title: 'Доска добрых дел',
        visible: true,
        to: RouteNames.Applications.MutualAidBoard.Base,
      },
      {
        id: 'DB1B52C6-D528-4ED0-A940-44735DC0FE38',
        title: 'Стать волонтером',
        visible: true,
        to: RouteNames.Applications.BecomeVolunteer.Base,
      },
      {
        id: 'DA0E3F60-AC41-499D-987E-A11FF5DC1C49',
        title: 'Помогу делом',
        visible: true,
        to: RouteNames.Applications.HelpWithTask.Base,
      },
      {
        id: '03326C81-1449-4C13-B6F6-2CF1F653C004',
        title: 'Геймификация',
        visible: true,
        to: RouteNames.Applications.Presents.Base,
      },
      {
        id: '70E3E7EC-B7E8-4800-A123-A24885362211',
        title: 'Сотрудничество',
        visible: true,
        to: RouteNames.Applications.Cooperation.Base,
      },
    ],
  },
];
